import { takeLatest, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { resolveError } from 'utils/resolveError';
import api from 'api/client';
import * as download from 'reducer/rDownload';
import * as message from 'reducer/rMessageBox';

/**
 * 다운로드 이력.
 *
 * 파트너 계정이 남의 것을 보지 못하게 하는 것은 서버가 한다 — 화면이 `clientId` 를 보내도
 * 서버가 자기 소속으로 덮는다. 여기서 거르면 규칙이 두 곳에 생긴다.
 */
export function* sDownload() {
    yield takeLatest(download.fetchDownloadRequest, fetchDownload);
}

function* fetchDownload(action) {
    try {
        const { page = 0, size = 20, keyword, sortBy, sortOrder } = action.payload ?? {};

        const params = { page, size };
        if (keyword) params.keyword = keyword;
        if (sortBy) params.sortBy = sortBy;
        if (sortOrder) params.sortOrder = sortOrder;

        const response = yield call(() => api.get('/downloads', { params }));

        if (response.data.resultCode === '0000') {
            yield put(download.fetchDownloadSuccess(response.data.data));
        } else {
            const msg = resolveError(response.data)
                || i18next.t('common.unexpectedError');
            yield put(download.fetchDownloadFailure(msg));
            yield put(message.fetchErrorMessageBoxRequest(msg));
        }
    } catch (error) {
        const msg = error.response?.status === 401
            ? i18next.t('common.sessionExpired')
            : i18next.t('common.unexpectedError');
        yield put(download.fetchDownloadFailure(msg));
        yield put(message.fetchErrorMessageBoxRequest(msg));
    }
}
